var i = /* @__PURE__ */ ((r) => (r.global = "g", r.multiLine = "m", r.insensitive = "i", r.sticky = "y", r.unicode = "u", r.singleLine = "s", r.indices = "d", r))(i || {}), c = /* @__PURE__ */ ((r) => (r.repeat = "repeat", r.keyboard = "keyboard", r.number = "number", r.alphabet = "alphabet", r))(c || {}), s = /* @__PURE__ */ ((r) => (r.length = "length", r.charPool = "charPool", r.char = "char", r.regex = "regex", r.blocklist = "blocklist", r.hibp = "hibp", r.sequence = "sequence", r))(s || {});
class n {
  config;
  constructor(t) {
    this.config = t;
  }
}
class o extends n {
}
class a extends n {
}
export {
  a as AsyncRule,
  i as RegexFlags,
  s as RuleType,
  c as SequenceType,
  o as SyncRule
};
